import React from 'react';
import SharePopup from '@/components/SharePopup';

type ShareContextType = {
  openShare: (url: string, text?: string) => void;
};

const ShareContext = React.createContext<ShareContextType | undefined>(undefined);

export const ShareProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [url, setUrl] = React.useState<string>('');
  const [text, setText] = React.useState<string>('');
  const [open, setOpen] = React.useState(false);

  const openShare = React.useCallback((u: string, t?: string) => {
    setUrl(u);
    setText(t || '');
    setOpen(true);
  }, []);

  React.useEffect(() => {
    const onEvt = (e: Event) => {
      try {
        const detail = (e as CustomEvent).detail || {};
        const u = String(detail?.url || '');
        const t = detail?.text ? String(detail.text) : '';
        if (u) openShare(u, t);
      } catch {}
    };
    document.addEventListener('tcard:openShare', onEvt as EventListener);
    return () => document.removeEventListener('tcard:openShare', onEvt as EventListener);
  }, [openShare]);

  return (
    <ShareContext.Provider value={{ openShare }}>
      {children}
      <SharePopup open={open} url={url} text={text} onClose={() => setOpen(false)} />
    </ShareContext.Provider>
  );
};

export function useShare() {
  const ctx = React.useContext(ShareContext);
  if (!ctx) throw new Error('useShare must be used within ShareProvider');
  return ctx;
}
